export default {
  // Common
  common: {
    welcome: 'Hoş Geldiniz',
    loading: 'Yükleniyor...',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    search: 'Ara...',
    filter: 'Filtrele',
    export: 'Dışa Aktar',
    refresh: 'Yenile',
    back: 'Geri',
    next: 'İleri',
    previous: 'Önceki',
    confirm: 'Onayla',
    yes: 'Evet',
    no: 'Hayır',
    close: 'Kapat',
    actions: 'İşlemler',
    status: 'Durum',
    active: 'Aktif',
    inactive: 'Pasif',
    enabled: 'Etkin',
    disabled: 'Devre Dışı',
    success: 'Başarılı',
    error: 'Hata',
    warning: 'Uyarı',
    info: 'Bilgi',
    apply: 'Uygula',
    download: 'İndir',
    upload: 'Yükle',
    view: 'Görüntüle',
    details: 'Detaylar',
    name: 'Ad',
    email: 'E-posta',
    phone: 'Telefon',
    address: 'Adres',
    country: 'Ülke',
    city: 'Şehir',
    state: 'Bölge',
    zipCode: 'Posta Kodu',
    createdAt: 'Oluşturma Tarihi',
    updatedAt: 'Güncelleme Tarihi',
    description: 'Açıklama',
    type: 'Tür',
    amount: 'Tutar',
    date: 'Tarih',
    time: 'Saat',
    from: 'Başlangıç',
    to: 'Bitiş',
    all: 'Tümü',
    none: 'Hiçbiri',
    select: 'Seç',
    selected: 'Seçili',
    total: 'Toplam',
    subtotal: 'Ara Toplam',
    pending: 'Beklemede',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
    completed: 'Tamamlandı',
    failed: 'Başarısız',
    processing: 'İşleniyor',
    cancelled: 'İptal Edildi',
    required: 'Zorunlu',
    optional: 'İsteğe Bağlı',
    today: 'Bugün',
    yesterday: 'Dün',
    thisWeek: 'Bu Hafta',
    thisMonth: 'Bu Ay',
    lastMonth: 'Geçen Ay',
    custom: 'Özel',
    range: 'Aralık',
    noData: 'Veri bulunamadı',
    noResults: 'Sonuç bulunamadı',
    showMore: 'Daha Fazla Göster',
    showLess: 'Daha Az Göster',
    expand: 'Genişlet',
    collapse: 'Daralt',
    clearAll: 'Tümünü Temizle',
    selectAll: 'Tümünü Seç',
    deselectAll: 'Seçimi Kaldır',
    copyToClipboard: 'Panoya Kopyala',
    copied: 'Kopyalandı!',
    notAvailable: 'N/A',
    upgrade: 'Yükselt',
  },

  // Auth
  auth: {
    login: 'Giriş Yap',
    logout: 'Çıkış Yap',
    email: 'E-posta',
    password: 'Şifre',
    rememberMe: 'Beni Hatırla',
    forgotPassword: 'Şifremi Unuttum?',
    signIn: 'Giriş Yap',
    signUp: 'Kayıt Ol',
    loginSuccess: 'Giriş başarıyla yapıldı',
    loginError: 'Geçersiz e-posta veya şifre',
    sessionExpired: 'Oturum süresi doldu. Lütfen tekrar giriş yapın.',
    adminPanel: 'Yönetici Paneli',
    needHelp: 'Yardıma mı ihtiyacınız var?',
    poweredBy: 'Güçlendirildi:',
  },

  // Navigation
  nav: {
    dashboard: 'Gösterge Paneli',
    instruments: 'Enstrümanlar',
    clients: 'Müşteriler',
    accounts: 'Hesaplar',
    trading: 'İşlem',
    reports: 'Raporlar',
    auditLog: 'Denetim Günlüğü',
    withdrawals: 'Para Çekme',
    deposits: 'Para Yatırma',
    settings: 'Ayarlar',
    plugins: 'Eklentiler',
    accountGroups: 'Hesap Grupları',
    kyc: 'KYC',
    apiDocs: 'API Dokümantasyonu',
    notifications: 'Bildirimler',
    upgrade: 'Yükselt',
    groupPricing: 'Grup Fiyatlandırması',
  },

  // Dashboard
  dashboard: {
    title: 'Gösterge Paneli',
    overview: 'Genel Bakış',
    stats: 'İstatistikler',
    totalClients: 'Toplam Müşteri',
    totalAccounts: 'Toplam Hesap',
    openPositions: 'Açık Pozisyonlar',
    todayPnL: 'Bugünkü K&Z',
    liveAccounts: 'Canlı Hesaplar',
    demoAccounts: 'Demo Hesaplar',
    activeClients: 'Aktif Müşteriler',
    activeTraders: 'Aktif Traderlar',
    newClients: 'Yeni Müşteriler',
    volumeChart: 'İşlem Hacmi (7 Gün)',
    pnlTrend: 'K&Z Trendi (30 Gün)',
    recentActivity: 'Son Aktiviteler',
    quickActions: 'Hızlı İşlemler',
    financialOverview: 'Finansal Genel Bakış',
    financialOverview30Days: 'Finansal Genel Bakış (30 Gün)',
    riskAlerts: 'Risk Uyarıları',
    riskDistribution: 'Risk Dağılımı',
    currentPlan: 'Mevcut Plan',
    planUsage: 'Plan Kullanımı',
    allowedMarkets: 'İzin Verilen Piyasalar',
    accountOverview: 'Hesap Genel Bakışı',
    activeUsers: 'Aktif Kullanıcılar',
    activeThisMonth: 'Bu Ay Aktif',
    plan: 'plan',
    feedLatency: 'Feed Gecikmesi',
    expires: 'Bitiş',
    cashFlowComparison: 'Nakit Akışı Karşılaştırması',
    totalTransactions: 'toplam işlem',
    totalDeposits: 'toplam yatırım',
    totalWithdrawals: 'toplam çekim',
  },

  // Instruments
  instruments: {
    title: 'Enstrüman Yönetimi',
    library: 'Enstrüman Kütüphanesi',
    enabled: 'Etkin Enstrümanlar',
    feed: 'Feed Enstrümanları',
    symbol: 'Sembol',
    category: 'Kategori',
    priceScale: 'Fiyat Ölçeği',
    leverage: 'Kaldıraç',
    spread: 'Spread',
    commission: 'Komisyon',
    enable: 'Etkinleştir',
    disable: 'Devre Dışı Bırak',
    bulkEnable: 'Toplu Etkinleştir',
    settings: 'Ayarlar',
    tradeMode: 'İşlem Modu',
    executionType: 'Çalıştırma Türü',
    forex: 'Forex',
    crypto: 'Kripto',
    stocks: 'Hisseler',
    indices: 'Endeksler',
    commodities: 'Emtialar',
    general: 'Genel',
    leverageLots: 'Kaldıraç ve Lotlar',
    spreads: 'Spreadler',
    commissions: 'Komisyonlar',
    riskManagement: 'Risk Yönetimi',
    advanced: 'Gelişmiş',
    maxLeverage: 'Maksimum Kaldıraç',
    minLotSize: 'Minimum Lot Büyüklüğü',
    maxLotSize: 'Maksimum Lot Büyüklüğü',
    lotStep: 'Lot Adımı',
    spreadType: 'Spread Türü',
    spreadMarkup: 'Spread Marjı',
    fixedSpread: 'Sabit Spread',
    commissionPerLot: 'Lot Başına Komisyon',
    commissionType: 'Komisyon Türü',
    stopLevel: 'Stop Seviyesi',
    freezeLevel: 'Dondurma Seviyesi',
    maxPositions: 'Maksimum Pozisyon',
    enableSuccess: 'Enstrüman başarıyla etkinleştirildi',
    disableSuccess: 'Enstrüman başarıyla devre dışı bırakıldı',
    updateSuccess: 'Ayarlar başarıyla güncellendi',
    bulkEnableSuccess: 'Enstrümanlar toplu olarak etkinleştirildi',
  },

  // Clients
  clients: {
    title: 'Müşteriler',
    clientsList: 'Müşteri Listesi',
    clientDetails: 'Müşteri Detayları',
    name: 'Ad',
    email: 'E-posta',
    phone: 'Telefon',
    country: 'Ülke',
    kycStatus: 'KYC Durumu',
    accountCount: 'Hesap Sayısı',
    totalBalance: 'Toplam Bakiye',
    lastLogin: 'Son Giriş',
    createdAt: 'Oluşturma Tarihi',
    verified: 'Doğrulandı',
    pending: 'Beklemede',
    rejected: 'Reddedildi',
    searchPlaceholder: 'Müşteri ara...',
    nameOrEmail: 'Ad veya e-posta…',
    editClient: 'Müşteriyi düzenle',
    configureOverride: 'Kullanıcı geçersiz kılmayı yapılandır',
    noClientsFound: 'Müşteri bulunamadı',
  },

  // Accounts
  accounts: {
    title: 'Hesaplar',
    accountsList: 'Hesap Listesi',
    accountDetails: 'Hesap Detayları',
    accountNumber: 'Hesap Numarası',
    accountType: 'Hesap Türü',
    accountGroup: 'Hesap Grubu',
    accountSettings: 'Hesap Ayarları',
    accountState: 'Hesap Durumu',
    accountActive: 'Hesap Aktif',
    balance: 'Bakiye',
    equity: 'Özsermaye',
    margin: 'Marjin',
    freeMargin: 'Serbest Marjin',
    marginLevel: 'Marjin Seviyesi',
    leverage: 'Kaldıraç',
    credit: 'Kredi',
    debit: 'Borç',
    adjustBalance: 'Bakiyeyi Ayarla',
    changeLeverage: 'Kaldıracı Değiştir',
    live: 'Canlı',
    demo: 'Demo',
    searchPlaceholder: 'Hesap numarası veya e-posta ile ara...',
    accountNumberOrEmail: 'Hesap numarası veya e-posta…',
    balanceChange: 'Bakiye Değişikliği',
    reasonForAdjustment: 'Ayarlama nedeni...',
    accountUpdatedSuccess: 'Hesap başarıyla güncellendi',
    noAccountsFound: 'Hesap bulunamadı',
  },

  // Trading
  trading: {
    title: 'İşlem',
    positions: 'Pozisyonlar',
    orders: 'Emirler',
    history: 'Geçmiş',
    symbol: 'Sembol',
    side: 'Yön',
    volume: 'Hacim',
    openPrice: 'Açılış Fiyatı',
    currentPrice: 'Güncel Fiyat',
    pnl: 'K&Z',
    buy: 'Al',
    sell: 'Sat',
    open: 'Açık',
    pending: 'Beklemede',
    closed: 'Kapalı',
    closedAt: 'Kapatılma Zamanı',
    openedAt: 'Açılma Zamanı',
    price: 'Fiyat',
    totalTrades: 'Toplam İşlem',
    winningTrades: 'Kazanan İşlemler',
    losingTrades: 'Kaybeden İşlemler',
    totalPnL: 'Toplam K&Z',
    account: 'Hesap',
    status: 'Durum',
    swap: 'Swap',
    commission: 'Komisyon',
    ticket: 'Bilet',
    noPositions: 'Açık pozisyon bulunamadı',
    noOrders: 'Bekleyen emir bulunamadı',
    noHistory: 'İşlem geçmişi bulunamadı',
    bid: 'Alış',
    ask: 'Satış',
    tradingManagement: 'İşlem Yönetimi',
    liveMonitoring: 'Canlı İzleme',
    disconnected: 'Bağlantı Kesildi',
    activeTraders: 'Aktif Traderlar',
    openPositions: 'Açık Pozisyonlar',
    pendingOrders: 'Bekleyen Emirler',
    floatPnL: 'Değişken K&Z',
    accountState: 'Hesap Durumu',
    marginCall: 'MARJİN ÇAĞRISI',
    stopOutRisk: 'STOP OUT RİSKİ',
    live: 'CANLI',
    offline: 'ÇEVRİMDIŞI',
    snapshot: 'ANLИК GÖRÜNTÜ',
    marginLvl: 'Marjin Seviyesi',
    openTrades: 'Açık İşlemler',
    freeMargin: 'Serbest Marjin',
    marginUsed: 'Kullanılan Marjin',
    balance: 'Bakiye',
    equity: 'Özsermaye',
    credit: 'Kredi',
    slTp: 'SL / TP',
    fees: 'Ücretler',
    netPnL: 'Net K&Z',
    grossPnL: 'Brüt K&Z',
    reason: 'Neden',
    openedClosed: 'Açıldı / Kapandı',
    closePrice: 'Kapanış Fiyatı',
    reserved: 'Rezerve',
    reservedMargin: 'Rezerve Marjin',
    created: 'Oluşturuldu',
    triggerPrice: 'Tetikleme Fiyatı',
    duration: 'Süre',
    closedTrades: 'Kapalı İşlemler',
    activeTrades: 'Aktif',
    stopLoss: 'Stop Loss',
    takeProfit: 'Take Profit',
    closePosition: 'Pozisyonu Kapat',
    cancelOrder: 'Emri İptal Et',
    modifyPosition: 'Pozisyonu Düzenle',
    thisActionCannotBeUndone: 'Bu işlem geri alınamaz',
    enterStopLoss: 'Stop loss fiyatı girin',
    enterTakeProfit: 'Take profit fiyatı girin',
    filterTrading: 'İşlemleri Filtrele',
    traderSymbolAccount: 'Trader, sembol, hesap…',
    noFound: '{tab} bulunamadı',
    showingOf: '{total} traderdan {from}–{to} gösteriliyor',
    traderCount: '{count} trader · {total} {tab}',
    positionClosedSuccess: 'Pozisyon başarıyla kapatıldı',
    orderCancelledSuccess: 'Emir başarıyla iptal edildi',
    positionModifiedSuccess: 'Pozisyon başarıyla düzenlendi',
    failedToClosePosition: 'Pozisyon kapatılamadı',
    failedToCancelOrder: 'Emir iptal edilemedi',
    failedToModifyPosition: 'Pozisyon düzenlenemedi',
    invalidPosition: 'Geçersiz pozisyon: ID eksik',
  },

  // Reports
  reports: {
    title: 'Raporlar',
    exposure: 'Maruz Kalma Raporu',
    profitability: 'Müşteri Karlılığı',
    daily: 'Günlük Rapor',
    dateRange: 'Tarih Aralığı',
    totalExposure: 'Toplam Maruz Kalma',
    netVolume: 'Net Hacim',
    topWinners: 'En Kazançlılar',
    topLosers: 'En Kayıplılar',
    buyVolume: 'Alış Hacmi',
    sellVolume: 'Satış Hacmi',
    positionCount: 'Pozisyon Sayısı',
    winRate: 'Kazanma Oranı',
    rank: 'Sıra',
    client: 'Müşteri',
    noData: 'Veri bulunamadı',
    totalVolume: 'Toplam Hacim',
    commission: 'Komisyon',
    activeAccounts: 'Aktif Hesaplar',
    export: 'Dışa Aktar',
    download: 'İndir',
    positions: 'Pozisyonlar',
    trades: 'İşlemler',
    winning: 'Kazanan',
    losing: 'Kaybeden',
  },

  // Settings
  settings: {
    title: 'Ayarlar',
    brokerInfo: 'Broker Bilgileri',
    brokerSettings: 'Broker Ayarları',
    brokerName: 'Broker Adı',
    brokerNameRequired: 'Broker Adı *',
    brokerLogo: 'Broker Logosu',
    brokerStatus: 'Broker Durumu',
    domain: 'Alan Adı',
    primaryColor: 'Ana Renk',
    secondaryColor: 'İkincil Renk',
    logo: 'Logo',
    supportEmail: 'Destek E-postası',
    supportPhone: 'Destek Telefonu',
    generalInfo: 'Genel Bilgiler',
    branding: 'Marka',
    accountGroups: 'Hesap Grupları',
    addNewGroup: 'Yeni Grup Ekle',
    createFirstGroup: 'İlk Grubunuzu Oluşturun',
    noGroupsFound: 'Hesap grubu bulunamadı',
    default: 'Varsayılan',
    maxLeverage: 'Maksimum Kaldıraç',
    marginCall: 'Marjin Çağrısı',
    stopOut: 'Stop Out',
    commission: 'Komisyon',
    maxLotSize: 'Maksimum Lot Büyüklüğü',
    execution: 'Çalıştırma',
    hedgingAllowed: 'Hedge İzinli',
    scalpingAllowed: 'Scalping İzinli',
    eaTrading: 'EA İşlemi',
    nbpEnabled: 'NBP Etkin',
    saving: 'Kaydediliyor...',
    groupName: 'Grup Adı',
    description: 'Açıklama',
    editGroup: 'Grubu Düzenle',
    deleteGroup: 'Grubu Sil',
    cannotDeleteDefault: 'Varsayılan grup silinemez',
    confirmDelete: '"{name}" grubunu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    groupCreatedSuccess: 'Grup başarıyla oluşturuldu',
    groupUpdatedSuccess: 'Grup başarıyla güncellendi',
    groupDeletedSuccess: 'Grup başarıyla silindi',
    failedToSave: 'Grup kaydedilemedi',
    failedToDelete: 'Grup silinemedi',
    failedToLoad: 'Hesap grupları yüklenemedi',
    configureYourBroker: 'Broker bilgilerinizi ve tercihlerinizi yapılandırın',
    loadingSettings: 'Ayarlar yükleniyor...',
    legalName: 'Yasal Ad',
    licenseNumber: 'Lisans Numarası',
    environment: 'Ortam',
    contactInformation: 'İletişim Bilgileri',
    readOnly: 'Salt okunur',
    readOnlyContactSupport: 'Salt okunur — değiştirmek için destekle iletişime geçin',
    supportedLanguages: 'Desteklenen Diller',
    selectLanguagesDescription: 'Müşteri portalında hangi dillerin kullanılabileceğini seçin. En az bir dil seçilmelidir.',
    systemLimits: 'Sistem Sınırları',
    maxAccounts: 'Maksimum Hesap',
    maxConcurrentTrades: 'Maksimum Eşzamanlı İşlem',
    maintenanceMode: 'Bakım Modu',
    enableMaintenanceMode: 'Bakım Modunu Etkinleştir',
    maintenanceModeDescription: 'Etkinleştirildiğinde, müşteriler platform yerine bakım mesajını görecek',
    maintenanceMessage: 'Bakım Mesajı',
    maintenanceMessagePlaceholder: 'Şu anda zamanlanmış bakım gerçekleştiriyoruz. Lütfen kısa süre sonra tekrar deneyin.',
    saveChanges: 'Değişiklikleri Kaydet',
    howToConnectDomain: 'Alan adınızı nasıl bağlarsınız',
    unlockToEdit: 'Düzenlemek için kilidini aç',
    lockDomain: 'Alan adını kilitle',
    changingDomainWarning: 'Alan adını değiştirmek müşteri erişimini kesebilir. Kilidini açmak istediğinizden emin misiniz?',
    changingDomainWarningLong: 'Alan adını değiştirmek müşteri erişimini ve DNS ayarlarını geçici olarak bozabilir. Devam etmek istediğinizden emin misiniz?',
    domainBreakWarning: '⚠️ Alan adını değiştirmek mevcut müşteri erişimini geçici olarak bozabilir',
    domainBreakWarningLong: '⚠️ Alan adını değiştirmek mevcut müşteri erişimini ve DNS yönlendirmesini geçici olarak bozabilir',
  },

  // Account Groups
  accountGroups: {
    title: 'Hesap Grupları',
    activeGroups: 'aktif',
    defaultGroups: 'varsayılan',
    addNewGroup: 'Yeni Grup Ekle',
    createFirstGroup: 'İlk Grubunuzu Oluşturun',
    noGroupsFound: 'Hesap grubu bulunamadı',
    groupDetails: 'Grup Detayları',
    pricingOverrides: 'Fiyat Geçersiz Kılmaları',
    riskSettings: 'Risk Ayarları',
    tradingSettings: 'İşlem Ayarları',
  },

  // Group Pricing
  groupPricing: {
    title: 'Grup Fiyat Geçersiz Kılmaları',
    infoBanner: 'Hesap Grubu Fiyat Geçersiz Kılmaları',
    infoDescription: 'Tüm hesap grupları için özel fiyatlandırma yapılandırın. Broker düzeyindeki varsayılanları kullanmak için alanları boş (NULL) bırakın.',
    editPricingOverrides: 'Fiyat Geçersiz Kılmalarını Düzenle',
    spreadMarkup: 'Spread Marjı',
    spreadMarkupPips: 'Spread Marjı (pip)',
    commission: 'Komisyon',
    commissionPerLot: 'Lot Başına Komisyon (USD)',
    maxLeverageOverride: 'Maksimum Kaldıraç Geçersiz Kılma',
    brokerDefault: 'Broker Varsayılanı',
    useBrokerDefault: 'Broker Varsayılanını Kullan',
    clearUseBrokerDefault: 'Temizle (broker varsayılanını kullan)',
    saveOverrides: 'Geçersiz Kılmaları Kaydet',
    overridesUpdatedSuccess: 'Grup fiyat geçersiz kılmaları başarıyla güncellendi',
    failedToUpdate: 'Geçersiz kılmalar güncellenemedi',
    leaveEmptyInfo: 'Broker düzeyindeki varsayılanları kullanmak için alanları boş bırakın. Yalnızca bu grup için geçersiz kılınması gereken değerleri ayarlayın.',
    pips: 'pip',
    perLot: '/lot',
  },

  // KYC
  kyc: {
    title: 'KYC Paneli',
    allKyc: 'Tüm KYC',
    allStatus: 'Tüm Durumlar',
    allKycStatus: 'Tüm KYC Durumları',
    pending: 'Beklemede',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
    verified: 'Doğrulandı',
    actionNeeded: 'İşlem gerekli',
    awaitingAction: 'İşlem bekleniyor',
    allCaughtUp: 'Hepsi tamamlandı!',
    noApplications: 'Şu anda bekleyen KYC başvurusu yok.',
    searchPlaceholder: 'Ad, e-posta veya ID ile ara...',
    nameEmailOrId: 'ID, ad veya e-posta…',
    confirmApproval: 'KYC onayını onayla',
    confirmRejection: 'Reddi onayla — bir neden girin (zorunlu).',
    rejectionReason: 'Bu başvurunun neden reddedildiğini açıklayın (zorunlu)',
    approveSuccess: 'KYC başarıyla onaylandı',
    rejectSuccess: 'KYC başarıyla reddedildi',
    failedToApprove: 'KYC onaylanamadı',
    failedToReject: 'KYC reddedilemedi',
    basicVerified: 'Temel Doğrulandı',
    fullVerified: 'Tam Doğrulandı',
    allApplications: 'Tüm Başvurular',
    kycVerification: 'KYC Doğrulama',
    reviewManageDesc: 'Müşteri doğrulama başvurularını inceleyin ve yönetin',
    pluginSettings: 'Eklenti Ayarları',
    reviewKycApplication: 'KYC Başvurusunu İncele',
    verificationLevel: 'Doğrulama Seviyesi',
    personalInformation: 'Kişisel Bilgiler',
    fullName: 'Ad Soyad',
    dateOfBirth: 'Doğum Tarihi',
    nationality: 'Uyruk',
    addressLabel: 'Adres',
    sourceOfFunds: 'Fon Kaynağı',
    noPersonalData: 'Henüz kişisel veri gönderilmedi',
    uploadedDocuments: 'Yüklenen Belgeler',
    noDocumentsUploaded: 'Henüz belge yüklenmedi',
    yourDecision: 'Kararınız',
    approve: 'Onayla',
    reject: 'Reddet',
    rejectionReasonLabel: 'Red Nedeni',
    submitting: 'Gönderiliyor…',
    submitReview: 'İncelemeyi Gönder',
    previewNotAvailable: 'Önizleme mevcut değil',
    downloadFile: 'Dosyayı İndir',
    uploaded: 'Yüklendi',
    pendingReview: 'İnceleme Bekliyor',
    allLevels: 'Tüm Seviyeler',
    allStatuses: 'Tüm Durumlar',
    allActions: 'Tüm İşlemler',
    userCol: 'Kullanıcı',
    currentLevel: 'Mevcut Seviye',
    docsCol: 'Belgeler',
    lastUpdated: 'Son Güncelleme',
    levelCol: 'Seviye',
    actionCol: 'İşlem',
    performedBy: 'Yapan',
    detailsCol: 'Detaylar',
    dateTime: 'Tarih ve Saat',
    submittedCol: 'Gönderildi',
    noApplicationsFound: 'Başvuru bulunamadı',
    noAuditRecords: 'Denetim kaydı bulunamadı',
    noMatchingApplications: 'Eşleşen başvuru yok',
    noPendingApplications: 'Bekleyen başvuru yok',
    systemAuto: 'Sistem (Otomatik)',
    admin: 'Yönetici',
    traderLabel: 'Trader',
    upgradedTo: 'Yükseltildi:',
    pendingApplications: 'bekleyen başvuru',
    pendingApplicationsPlural: 'bekleyen başvuru',
    users: 'kullanıcı',
    usersPlural: 'kullanıcı',
    records: 'kayıt',
    recordsPlural: 'kayıt',
    applications: 'başvuru',
    applicationsPlural: 'başvuru',
    totalUsers: 'Toplam Kullanıcı',
    basicVerifiedStat: 'Temel Doğrulandı',
    moderateVerified: 'Orta Doğrulandı',
    fullyVerified: 'Tam Doğrulandı',
    pendingSuffix: '+{count} beklemede',
    levelBasic: 'Temel',
    levelModerate: 'Orta',
    levelVerified: 'Doğrulandı',
    notStarted: 'Başlamadı',
    none: 'Yok',
    unknown: 'Bilinmiyor',
    review: 'İncele',
    auditLog: 'Denetim Günlüğü',
    requiredDocuments: 'Gerekli Belgeler',
    requiredDocsDesc: 'Traderların her KYC seviyesi için yüklemesi gereken belgeleri seçin. Her seviye için en az bir belge gereklidir.',
    kycDocuments: '{level} KYC Belgeleri',
    selected: '{count} seçildi',
    approvalMode: 'Onay Modu',
    manualReview: 'Manuel İnceleme',
    autoApprove: 'Otomatik Onay',
    autoApproveLevels: 'Otomatik Onay Seviyeleri',
    basicKyc: 'Temel KYC',
    moderateKyc: 'Orta KYC',
    verifiedKyc: 'Doğrulanmış KYC',
    enforceOnDeposit: 'Para Yatırmada KYC Zorunlu Kıl',
    enforceOnWithdrawal: 'Para Çekmede KYC Zorunlu Kıl',
    basic: 'Temel',
    moderate: 'Orta',
    verified: 'Doğrulandı',
    howItWorks: 'Nasıl çalışır:',
    howItWorksBullet1: 'Temel eşiğin altındaki tutarlar: KYC gerekmez',
    howItWorksBullet2: 'Temel üzerindeki tutarlar: Temel KYC gerekir',
    howItWorksBullet3: 'Orta üzerindeki tutarlar: Orta KYC gerekir',
    howItWorksBullet4: 'Doğrulanmış üzerindeki tutarlar: Tam doğrulama gerekir',
    saveConfiguration: 'Yapılandırmayı Kaydet',
    savingConfiguration: 'Kaydediliyor...',
    openKycDashboard: 'KYC Panelini Aç',
    enableToViewStats: 'İstatistikleri görmek için eklentiyi etkinleştirin',
    statNone: 'Yok',
    docGovIdFrontLabel: 'Devlet Kimliği (Ön)',
    docGovIdFrontDesc: 'Pasaport, ehliyet veya nüfus cüzdanı — ön yüz',
    docGovIdBackLabel: 'Devlet Kimliği (Arka)',
    docGovIdBackDesc: 'Kimlik kartının arka yüzü',
    docSelfieLabel: 'Kimlikli Selfie',
    docSelfieDesc: 'Yüzün yanında kimlik tutarak çekilen fotoğraf',
    docProofAddressLabel: 'Adres Kanıtı',
    docProofAddressDesc: 'Fatura veya banka ekstresi (3 aydan eski olmayan)',
    docBankStatementLabel: 'Banka Ekstresi',
    docBankStatementDesc: 'Ad ve hesap gösteren güncel ekstre',
    docSourceFundsLabel: 'Fon Kaynağı',
    docSourceFundsDesc: 'İşlem fonlarının kaynağını kanıtlayan belge',
    docEmploymentLabel: 'İstihdam Mektubu',
    docEmploymentDesc: 'İşveren onay mektubu',
    docTaxIdLabel: 'Vergi Kimlik Belgesi',
    docTaxIdDesc: 'Vergi kimlik sertifikası',
    docOtherLabel: 'Diğer Belgeler',
    docOtherDesc: 'Ek destekleyici belgeler',
    auditActions: {
      submitted: 'Gönderildi',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
      document_uploaded: 'Belge Yüklendi',
      document_approved: 'Belge Onaylandı',
      document_rejected: 'Belge Reddedildi',
      level_upgraded: 'Seviye Yükseltildi',
      resubmission: 'Yeniden Gönderim',
    },
  },

  // Deposits
  deposits: {
    title: 'Para Yatırma',
    allDeposits: 'Tüm Yatırımlar',
    allStatuses: 'Tüm Durumlar',
    pending: 'Beklemede',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
    completed: 'Tamamlandı',
    searchPlaceholder: 'Yatırım ara…',
    searchByIdNameEmail: 'ID, trader adı veya e-posta ile ara…',
    idNameOrEmail: 'ID, ad veya e-posta…',
    depositProof: 'Yatırım kanıtı',
    depositProofPdf: 'Yatırım kanıtı PDF',
    amount: 'Tutar',
    method: 'Yöntem',
    status: 'Durum',
    trader: 'Trader',
    date: 'Tarih',
    actions: 'İşlemler',
    approve: 'Onayla',
    reject: 'Reddet',
    confirmApproval: 'Onayı onayla — bu işlem trader\'ın bakiyesini artıracak.',
    confirmRejection: 'Reddi onayla — bir neden girin (isteğe bağlı).',
    rejectionReason: 'Red nedeni (isteğe bağlı)…',
    approveSuccess: 'Para yatırma başarıyla onaylandı',
    rejectSuccess: 'Para yatırma başarıyla reddedildi',
    failedToApprove: 'Para yatırma onaylanamadı',
    failedToReject: 'Para yatırma reddedilemedi',
    noDepositsFound: 'Yatırım bulunamadı',
    proofThumbnail: 'Kanıt küçük resmi',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
    openInNewTab: 'Yeni sekmede aç',
    bank: 'Banka',
    crypto: 'Kripto',
    card: 'Kart',
    bankPerCountry: 'Banka (Ülkeye Göre)',
    bankPerUser: 'Banka (Kullanıcıya Göre)',
    bankTransfer: 'Banka Transferi',
    bankTransferPerCountry: 'Banka Transferi (Ülkeye Göre)',
    bankTransferPerUser: 'Banka Transferi (Kullanıcıya Göre)',
    averageDeposit: 'Ortalama Yatırım',
  },

  // Withdrawals
  withdrawals: {
    title: 'Para Çekme',
    allWithdrawals: 'Tüm Çekimler',
    allStatuses: 'Tüm Durumlar',
    pending: 'Beklemede',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
    completed: 'Tamamlandı',
    searchPlaceholder: 'Çekim ara…',
    searchByIdNameEmail: 'ID, trader adı veya e-posta ile ara…',
    idNameOrEmail: 'ID, ad veya e-posta…',
    amount: 'Tutar',
    method: 'Yöntem',
    status: 'Durum',
    trader: 'Trader',
    date: 'Tarih',
    actions: 'İşlemler',
    approve: 'Onayla',
    reject: 'Reddet',
    confirmApproval: 'Onayı onayla — fonlar trader\'ın ödeme bilgilerine aktarılacak.',
    confirmWithdrawalApproval: 'Para çekme onayını onayla — fonlar trader\'ın ödeme bilgilerine aktarılacak.',
    confirmRejection: 'Reddi onayla — bir neden girin (isteğe bağlı).',
    rejectionReason: 'Red nedeni (isteğe bağlı)…',
    approveSuccess: 'Para çekme başarıyla onaylandı',
    rejectSuccess: 'Para çekme başarıyla reddedildi',
    failedToApprove: 'Para çekme onaylanamadı',
    failedToReject: 'Para çekme reddedilemedi',
    noWithdrawalsFound: 'Çekim bulunamadı',
    averageWithdrawal: 'Ortalama Çekim',
  },

  // Audit Log
  auditLog: {
    title: 'Denetim Günlüğü',
    allActions: 'Tüm İşlemler',
    allEvents: 'Tüm Olaylar',
    allLevels: 'Tüm Seviyeler',
    searchPlaceholder: 'Denetim günlüğünde ara…',
    emailActionOrId: 'E-posta, işlem veya ID…',
    event: 'Olay',
    user: 'Kullanıcı',
    action: 'İşlem',
    timestamp: 'Zaman Damgası',
    details: 'Detaylar',
    level: 'Seviye',
    info: 'Bilgi',
    warning: 'Uyarı',
    error: 'Hata',
    critical: 'Kritik',
    noLogsFound: 'Denetim günlüğü bulunamadı',
    administrativeAction: 'Bir yönetimsel işlem kaydedildi.',
    filterAuditLog: 'Denetim Günlüğünü Filtrele',
    reset: 'Sıfırla',
    eventType: 'Olay Türü',
    apply: 'Uygula',
    totalEvents: 'Toplam Olay',
    depositEvents: 'Yatırım Olayları',
    withdrawalEvents: 'Çekim Olayları',
    noEventsMatch: 'Bu filtreyle eşleşen olay yok',
    noEntriesMatch: 'Mevcut filtreyle eşleşen denetim girişi yok.',
    showAll: 'Tümünü Göster',
    events: 'olay',
    eventsPlural: 'olay',
    totalEventsRecorded: 'Toplam kaydedilen olay',
    performedBy: 'Yapan',
    amount: 'Tutar',
    paymentMethod: 'Ödeme Yöntemi',
    balanceChange: 'Bakiye Değişikliği',
    statusChange: 'Durum Değişikliği',
    rejectionReason: 'Red Nedeni',
    actionWithdrawalRequested: 'Para Çekme Talep Edildi',
    actionDepositSubmitted: 'Para Yatırma Gönderildi',
    actionProofUploaded: 'Kanıt Yüklendi',
    actionDepositApproved: 'Para Yatırma Onaylandı',
    actionDepositRejected: 'Para Yatırma Reddedildi',
    actionWithdrawalApproved: 'Para Çekme Onaylandı',
    actionWithdrawalRejected: 'Para Çekme Reddedildi',
    actionFundsLocked: 'Fonlar Kilitlendi',
    actionFundsReturned: 'Fonlar İade Edildi',
    fundsLockedSummary: 'Para çekme incelemesi beklenirken trader hesabından fonlar kilitlendi.',
    fundsReturnedSummary: 'Red sonrası kilitli fonlar trader\'a iade edildi.',
    depositsTab: 'Yatırımlar',
    withdrawalsTab: 'Çekimler',
  },

  // Plugins
  plugins: {
    title: 'Eklentiler',
    backToPlugins: 'Eklentilere Dön',
    searchPlaceholder: 'Eklenti ara…',
    countrySelectNoMatch: 'Eşleşme yok',
    configurePlugin: 'Eklentiyi Yapılandır',
    pressEscToClose: 'Kapatmak için {key} tuşuna basın',
    loadingUsers: 'Yükleniyor…',
    available: 'Mevcut',
    active: 'Aktif',
    activate: 'Etkinleştir',
    deactivate: 'Devre Dışı Bırak',
    configure: 'Yapılandır',
    documentation: 'Dokümantasyon',
    settings: 'Ayarlar',
    noPluginsFound: 'Eklenti bulunamadı',
    pluginDetails: 'Eklenti Detayları',
    version: 'Sürüm',
    author: 'Yazar',
    description: 'Açıklama',
    filterInactive: 'Pasif',
    paymentGateways: 'Ödeme Ağ Geçitleri',
    stripeTitle: 'Stripe',
    stripeDescription: 'Stripe üzerinden ödeme kabul edin',
    paypalTitle: 'PayPal',
    paypalDescription: 'PayPal üzerinden ödeme kabul edin',
    communicationTools: 'İletişim Araçları',
    twilioTitle: 'Twilio SMS',
    twilioDescription: 'SMS bildirimleri gönder',
    mailgunTitle: 'Mailgun',
    mailgunDescription: 'E-posta teslim hizmeti',
    bankFieldAccountHolder: 'Hesap sahibi',
    bankFieldBankName: 'Banka adı',
    bankFieldAccountNumber: 'Hesap numarası',
    bankFieldRoutingNumber: 'Yönlendirme numarası (isteğe bağlı)',
    bankFieldSetAsDefault: 'Varsayılan olarak ayarla (genel yedek)',
    copyTradingTitle: 'Copy Trading',
    copyTradingDescription: 'Copy trading özelliklerini etkinleştir',
    tradingTools: 'İşlem Araçları',
    mam: 'MAM/PAMM',
    apiKey: 'API Anahtarı',
    apiSecret: 'API Gizli Anahtarı',
    accountSid: 'Hesap SID',
    authToken: 'Kimlik Doğrulama Tokeni',
    authDomain: 'Kimlik Doğrulama Alanı',
    appId: 'Uygulama ID',
    loadingPlugins: 'Eklentiler yükleniyor…',
    noPluginsMatch: 'Kriterlerinizle eşleşen eklenti yok',
    tryDifferentSearch: 'Farklı bir arama veya filtre deneyin',
    tryAdjustingSearch: 'Aramanızı veya filtrenizi ayarlamayı deneyin',
    activeCount: '{count} aktif · {owned} sahip olunan · {available} mağazada',
    ofPurchasedActive: 'Satın alınan {count} tanesi aktif',
    expired: 'Süresi Doldu',
    expires: 'Bitiş',
    free: 'Ücretsiz',
    buyPlugin: 'Satın Al — ${price}{cycle}',
    openInFullPage: 'Tam sayfada aç',
    noConfigPanel: 'Bu eklenti için yapılandırma paneli mevcut değil.',
    currentStatus: 'Mevcut Durum',
    failedToUpdateKyc: 'KYC yapılandırması güncellenemedi',
    filterAll: 'Tümü',
    filterActive: 'Aktif',
    filterOwned: 'Sahip Olunan',
    filterStore: 'Mağaza',
    pluginNotFound: 'Eklenti bulunamadı',
    loadingPlugin: 'Eklenti yükleniyor...',
    failedToLoadPlugin: 'Eklenti yüklenemedi',
    noConfigAvailable: 'Bu eklenti için yapılandırma paneli mevcut değil.',
    activeStatus: 'Aktif',
    editLabel: 'Düzenle',
    newLabel: 'Yeni',
    addLabel: 'Ekle',
    saveLabel: 'Kaydet',
    cancelLabel: 'İptal',
    globalBankAccount: 'Global Banka Hesabı',
    addBankAccount: 'Banka hesabı ekle',
    defaultLabel: '(varsayılan)',
    cryptoWallet: 'Kripto Cüzdanı',
    addCryptoWallet: 'Kripto cüzdanı ekle',
    coinPlaceholder: 'Coin (örn. BTC)',
    networkPlaceholder: 'Ağ (örn. mainnet)',
    walletAddressPlaceholder: 'Cüzdan adresi',
    labelOptionalPlaceholder: 'Etiket (isteğe bağlı)',
    paymentLink: 'Ödeme Linki',
    addPaymentLink: 'Ödeme linki ekle',
    linkNamePlaceholder: 'Ad (örn. Stripe Checkout)',
    perUserBankAccount: 'Kullanıcı Başına Banka Hesabı',
    addUserBankMapping: 'Kullanıcı → banka eşlemesi ekle',
    editExistingAccount: 'Mevcut hesabı düzenle',
    assignedUsers: 'Atanan kullanıcılar',
    pickTraders: 'Trader(lar) seç',
    searchAddTrader: 'Trader ara ve ekle…',
    perCountryBankAccount: 'Ülke Başına Banka Hesabı',
    addCountryBankMapping: 'Ülke → banka eşlemesi ekle',
    mappedCountries: 'Eşlenen ülkeler',
    pickCountries: 'Ülke(ler) seç',
    searchAddCountries: 'Ülke ara ve ekle…',
    badgeActive: 'Aktif',
    badgeInactive: 'Pasif',
    badgeExpired: 'Süresi Doldu',
    purchasePlugin: 'Eklenti Satın Al',
    paymentMethod: 'Ödeme Yöntemi',
    generatePaymentAddress: 'Ödeme Adresi Oluştur',
    sendExactly: 'Tam olarak gönder',
    toAddressBelow: 'aşağıdaki adrese',
    paymentAddress: 'Ödeme Adresi',
    waitingForPayment: 'Ödeme bekleniyor...',
    paymentDetected: 'Ödeme tespit edildi! Onaylanıyor...',
    confirmationsReceived: '{count} onay alındı',
    confirmationsReceivedPlural: '{count} onay alındı',
    expiresIn: 'Bitiş:',
    paymentId: 'Ödeme ID:',
    paymentConfirmed: 'Ödeme Onaylandı!',
    pluginActivated: '{name} etkinleştirildi.',
    networkError: 'Ağ hatası. Lütfen tekrar deneyin.',
    failedToCreatePayment: 'Ödeme oluşturulamadı',
    paymentExpired: 'Ödeme süresi doldu. Lütfen yeni bir ödeme oluşturun.',
  },

  // API Docs
  apiDocs: {
    title: 'API Dokümantasyonu',
    authentication: 'Kimlik Doğrulama',
    baseUrl: 'Temel URL:',
    allRequestsRequire: 'Tüm istekler iki başlık gerektirir:',
    apiKeyManagement: 'Kapsam kontrollü API anahtarı yönetimi',
    billing: 'Faturalandırma',
    apiAccess: 'API Erişimi',
    apiAccessAddon: 'API Erişim eklentisi aktif',
    buyAddon: 'Eklenti Satın Al — $199/ay',
    getAccounts: 'GET /accounts',
    getAccountDetails: 'GET /accounts/:id',
    updateAccount: 'PATCH /accounts/:id',
    getDeposits: 'GET /deposits',
    approveDeposit: 'POST /deposits/:id/approve',
    rejectDeposit: 'POST /deposits/:id/reject',
    getWithdrawals: 'GET /withdrawals',
    approveWithdrawal: 'POST /withdrawals/:id/approve',
    rejectWithdrawal: 'POST /withdrawals/:id/reject',
    approvalsDescription: 'Para yatırma ve çekimleri programatik olarak onaylayın',
    approveDepositDesc: 'Para yatırmayı onayla (durum proof_uploaded olmalı). Hesap bakiyesini artırır, işlemi kaydeder, motoru bilgilendirir. Gövde: notes?. balance_before ve balance_after döndürür.',
    approveWithdrawalDesc: 'Bekleyen para çekmeyi onayla. Bakiye istek zamanında zaten kilitlendi. Gövde: notes?',
    restApi: 'REST API',
    baseUrlLabel: 'Temel URL:',
    yourApiKeys: 'API Anahtarlarınız',
    noApiKeysYet: 'Henüz API anahtarı yok',
    generateNewKey: 'Yeni Anahtar Oluştur',
    revokeKey: 'İptal Et',
    rateLimit: 'Oran limiti',
    maxKeys: 'Maksimum anahtar',
    reqPerMin: '{limit} istek/dak',
    exampleRequest: 'Örnek İstek',
    queryParameters: 'Sorgu Parametreleri',
    endpoints: 'uç nokta',
    endpointsPlural: 'uç nokta',
    includedInPlan: 'Enterprise planınıza dahil',
    addonActive: 'API Erişim eklentisi aktif',
    restApiAccess: 'REST API Erişimi',
    restApiDesc: 'REST API erişimi Enterprise planında veya herhangi bir plan için bağımsız eklenti olarak mevcuttur. Sistemlerinizi doğrudan broker platformunuza bağlayın.',
    featureReadClients: 'Müşterileri, hesapları ve işlem geçmişini okuyun',
    featureApprovePayments: 'Para yatırma ve çekimleri programatik olarak onaylayın',
    featureApiKeyManagement: 'Kapsam kontrollü API anahtarı yönetimi',
    featureRateLimit: 'Anahtar başına dakikada 60 isteğe kadar',
    featureInteractiveDocs: 'Panelinizde etkileşimli dokümantasyon',
    upgradeToEnterprise: 'Enterprise\'a Yükselt',
    buyAddonPrice: 'Eklenti Satın Al — $199/ay',
    generateApiKey: 'API Anahtarı Oluştur',
    keyName: 'Anahtar Adı',
    keyNamePlaceholder: 'örn. Production Anahtarı',
    scopes: 'Kapsamlar',
    generating: 'Oluşturuluyor...',
    generateKey: 'Anahtar Oluştur',
    keyGenerated: 'Anahtar Oluşturuldu',
    copySecretWarning: '⚠️ Gizli anahtarınızı şimdi kopyalayın — bir daha gösterilmeyecek.',
    apiKeyLabel: 'API Anahtarı',
    apiSecretLabel: 'API Gizli Anahtarı',
    done: 'Tamam',
    enterKeyName: 'Anahtar adı girin',
    failedToCreateKey: 'Anahtar oluşturulamadı',
    keyRevoked: 'Anahtar iptal edildi',
    confirmRevoke: 'Bu API anahtarını iptal et? Bu işlem geri alınamaz.',
  },

  // Notifications
  notifications: {
    title: 'Bildirim Ayarları',
    emailNotifications: 'E-posta Bildirimleri',
    smsNotifications: 'SMS Bildirimleri',
    pushNotifications: 'Push Bildirimleri',
    deposits: 'Para Yatırma',
    withdrawals: 'Para Çekme',
    newClients: 'Yeni Müşteriler',
    kycApplications: 'KYC Başvuruları',
    systemAlerts: 'Sistem Uyarıları',
    enabled: 'Etkin',
    disabled: 'Devre Dışı',
    saveSettings: 'Ayarları Kaydet',
    settingsSaved: 'Ayarlar başarıyla kaydedildi',
    notificationChannels: 'Bildirim Kanalları',
    configureChannels: 'Platformunuzun müşterilere uyarıları nasıl gönderdiğini yapılandırın. Yalnızca kurduğunuz kanalları etkinleştirin.',
    saveAll: 'Tümünü Kaydet',
    saving: 'Kaydediliyor...',
    enableToConfigure: '{title} yapılandırmak için etkinleştirin',
    emailSmtp: 'E-posta (SMTP)',
    emailSmtpSubtitle: 'Kendi SMTP sunucunuz üzerinden e-posta gönderin',
    recommended: 'Önerilen',
    smtpHost: 'SMTP Sunucusu',
    smtpPort: 'SMTP Portu',
    usernameEmail: 'Kullanıcı Adı / E-posta',
    passwordAppPassword: 'Şifre / Uygulama Şifresi',
    fromEmail: 'Gönderen E-posta',
    fromName: 'Gönderen Adı',
    useTls: 'TLS / STARTTLS Kullan',
    useTlsHint: 'Port 587 için önerilir. Port 465 (SSL) için devre dışı bırakın.',
    sendTestEmail: 'Test E-postası Gönder',
    pushFcm: 'Push Bildirimleri (FCM)',
    pushFcmSubtitle: 'Android, iOS ve Web için Firebase Cloud Messaging',
    pushSetupRequired: 'Kurulum gerekli',
    pushSetupDesc: 'Firebase Console → Proje Ayarları → Hizmet Hesapları → Yeni özel anahtar oluştur yoluna gidin. JSON dosyasını indirin ve aşağıya yükleyin.',
    serviceAccountCredentials: 'Hizmet Hesabı Kimlik Bilgileri',
    clientTokenStatus: 'İstemci Token Durumu',
    clientTokenDesc: 'Push tokenleri, müşteriler mobil/web\'de giriş yaptığında otomatik olarak kaydedilir. Manuel yapılandırma gerekmez.',
    testPush: 'Push Testi',
    webAppConfig: 'Web Uygulama Yapılandırması',
    webAppConfigured: 'Yapılandırıldı — {project}',
    webAppRequired: 'Tarayıcı ve mobil push için gerekli',
    webAppWhereToFind: 'Nerede bulunur',
    webAppWhereToFindDesc: 'Firebase Console → Proje Ayarları → Uygulamalarınız → Web uygulaması → SDK kurulumu ve yapılandırması',
    saveWebConfig: 'Web Yapılandırmasını Kaydet',
    vapidKey: 'VAPID Anahtarı',
    vapidKeyHint: '— Cloud Messaging sekmesi → Web Push sertifikaları → Anahtar çifti oluştur',
    credentialsOnFile: 'Dosyada kimlik bilgileri',
    credentialsStoredSecurely: 'Sunucuda güvenli şekilde saklanıyor',
    replaceCredentials: 'Değiştir',
    uploadServiceAccount: 'Hizmet hesabı JSON yükle',
    uploadServiceAccountHint: 'Seçmek için tıklayın — dosya doğrulanır ve sunucuda güvenli şekilde saklanır',
    uploadingValidating: 'Yükleniyor ve doğrulanıyor...',
    uploadSuccess: 'Firebase kimlik bilgileri başarıyla yüklendi',
    uploadFailed: 'Yükleme başarısız — dosyanın geçerli bir Firebase hizmet hesabı JSON\'ı olduğunu kontrol edin',
    saveWebConfigSuccess: 'Firebase web yapılandırması kaydedildi',
    saveWebConfigFailed: 'Web yapılandırması kaydedilemedi',
    smsTwilio: 'SMS (Twilio)',
    smsTwilioSubtitle: 'Telefon numarası olan müşterilere Twilio üzerinden SMS uyarıları gönderin',
    smsSetupRequired: 'Kurulum gerekli',
    smsSetupDesc: 'Kimlik bilgilerinizi console.twilio.com → Hesap → API anahtarları ve tokenler adresinden alın. Ayrıca bir Twilio telefon numarasına ihtiyacınız olacak.',
    accountSid: 'Hesap SID',
    accountSidHint: 'AC ile başlar...',
    authToken: 'Kimlik Doğrulama Tokeni',
    fromPhoneNumber: 'Gönderen Telefon Numarası',
    fromPhoneHint: 'E.164 formatı, örn. +905001234567',
    sendTestSms: 'Test SMS Gönder',
    statusConnected: 'Bağlandı',
    statusError: 'Hata',
    statusUntested: 'Test Edilmedi',
    statusTesting: 'Test Ediliyor...',
    notificationRouting: 'Bildirim Yönlendirme',
    notificationRoutingDesc: 'Her bildirim türünün hangi kanalları kullanacağını seçin',
    noChannelsEnabled: 'Etkin kanal yok',
    noChannelsEnabledDesc: 'Bildirim yönlendirmeyi yapılandırmak için yukarıdan en az bir kanal etkinleştirin',
    notifMarginCall: 'Marjin Çağrısı',
    notifMarginCallDesc: 'Hesap marjin seviyesi eşiğin altına düştüğünde',
    notifLiquidation: 'Tasfiye',
    notifLiquidationDesc: 'Pozisyonlar zorla kapatıldığında',
    notifDeposit: 'Para Yatırma',
    notifDepositDesc: 'Para yatırma onaylandığında',
    notifWithdrawal: 'Para Çekme',
    notifWithdrawalDesc: 'Para çekme işlendiğinde',
    notifTradeOpened: 'İşlem Açıldı',
    notifTradeOpenedDesc: 'Yeni bir pozisyon açıldığında',
    notifTradeClosed: 'İşlem Kapandı',
    notifTradeClosedDesc: 'Bir pozisyon kapandığında',
    failedToLoad: 'Bildirim ayarları yüklenemedi',
    failedToSave: 'Kaydedilemedi',
    testSuccess: '{channel} testi başarılı — gelen kutunuzu/cihazınızı kontrol edin',
    testFailed: '{channel} testi başarısız',
  },

  // Upgrade
  upgrade: {
    title: 'Planı Yükselt',
    currentPlan: 'Mevcut Plan',
    choosePlan: 'Plan Seç',
    basic: 'Temel',
    professional: 'Profesyonel',
    enterprise: 'Kurumsal',
    perMonth: '/ay',
    perYear: '/yıl',
    monthly: 'Aylık',
    annually: 'Yıllık',
    features: 'Özellikler',
    selectPlan: 'Plan Seç',
    currentPlanLabel: 'Mevcut Plan',
    upgradeTo: 'Yükselt:',
    contactSales: 'Satışla İletişime Geç',
    unlimitedClients: 'Sınırsız Müşteri',
    unlimitedAccounts: 'Sınırsız Hesap',
    advancedReporting: 'Gelişmiş Raporlama',
    prioritySupport: 'Öncelikli Destek',
    apiAccess: 'API Erişimi',
    customBranding: 'Özel Marka',
    whiteLabel: 'White Label',
    dedicatedManager: 'Özel Hesap Yöneticisi',
    upgradeAvailable: 'Yükseltme Mevcut',
    plan: 'Plan',
    unlock: 'Kilidi Aç',
    apiAccessFeature: ', API erişimi',
    andMore: '& daha fazlası',
    renew: 'Yenile',
  },

  // Theme
  theme: {
    light: 'Açık Mod',
    dark: 'Koyu Mod',
    toggle: 'Temayı Değiştir',
  },

  // Language
  language: {
    english: 'English',
    arabic: 'العربية',
    turkish: 'Türkçe',
    select: 'Dil Seç',
  },

  // Errors
  errors: {
    general: 'Bir şeyler yanlış gitti',
    networkError: 'Ağ hatası. Bağlantınızı kontrol edin.',
    unauthorized: 'Yetkisiz. Lütfen tekrar giriş yapın.',
    forbidden: 'Erişim reddedildi.',
    notFound: 'Kaynak bulunamadı.',
    serverError: 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
    actionFailed: 'İşlem başarısız',
  },

  // Success messages
  success: {
    saved: 'Başarıyla kaydedildi',
    updated: 'Başarıyla güncellendi',
    deleted: 'Başarıyla silindi',
    created: 'Başarıyla oluşturuldu',
    copied: 'Panoya kopyalandı',
  },

  // Time & Date
  time: {
    seconds: 'saniye',
    minutes: 'dakika',
    hours: 'saat',
    days: 'gün',
    weeks: 'hafta',
    months: 'ay',
    years: 'yıl',
    ago: 'önce',
    justNow: 'az önce',
    today: 'Bugün',
    yesterday: 'Dün',
    tomorrow: 'Yarın',
  },

  // Units
  units: {
    usd: 'USD',
    eur: 'EUR',
    gbp: 'GBP',
    lot: 'lot',
    lots: 'lot',
    pips: 'pip',
    percent: '%',
  },

  cascade: {
    settingsArchitecture: 'Ayar Mimarisi',
    title: 'Basamaklı Öncelik Sistemi',
    subtitle: 'Ayarlar en yüksek → en düşük önceliğe göre çözülür. Bir alanı',
    subtitleNull: 'boş (NULL)',
    subtitleFallthrough: 'bırakarak o katmanı atlayıp bir sonrakine geçebilirsiniz.',
    resolutionOrder: 'Çözüm Sırası:',
    firstNonNull: 'İlk null olmayan değer kazanır',
    highestPriority: 'En Yüksek Öncelik — Keşfetmek için herhangi bir katmana tıklayın',
    ifEmptyFallsThrough: '↓ boşsa, bir sonrakine geçer',
    priority: 'Öncelik',
    leaveFieldEmpty: 'Herhangi bir alanı boş bırakın (NULL)',
    skipLayer: 'bu katmanı atlayıp geçmek için',
    finalFallback: 'Son yedek — altında katman yok.',
    hardLimitsNote: 'ile işaretli alanlar',
    hardLimitsNote2: 'sistem genelinde uygulanan sert limitlerdir, hiçbir katman bunları atlayamaz.',
    layers: {
      userOverride: 'Kullanıcı Geçersiz Kılma',
      userSublabel: 'Müşteri başına özel anlaşmalar',
      userTooltip: 'En yüksek öncelik. Burada ayarlanan herhangi bir alan diğer her şeyin önüne geçer. VIP müşteriler, kısıtlı hesaplar veya özel anlaşmalar için kullanın.',
      userFallsTo: 'Hesap Grubu (P2)',
      accountGroup: 'Hesap Grubu',
      groupSublabel: 'VIP, Standart, Profesyonel seviyeleri',
      groupTooltip: 'Bu gruptaki tüm müşterilere uygulanır. Kullanıcı geçersiz kılma yoksa grup ayarları geçerli olur. Kademeli hesap türleri için idealdir.',
      groupFallsTo: 'Sembol Ayarları (P3)',
      symbolSettings: 'Sembol Ayarları',
      symbolSublabel: 'Enstrüman başına broker yapılandırması',
      symbolTooltip: 'Enstrüman başına fiyatlandırma ve çalıştırma kurallarını kontrol eder. Örn. XAUUSD, EURUSD\'den farklı spread marjı alır.',
      symbolFallsTo: 'Platform Varsayılanları (P4)',
      platformDefaults: 'Platform Varsayılanları',
      platformSublabel: 'Sistem yedeği ve sert üst limitler',
      platformTooltip: 'Varsayılanlar için en düşük öncelik, ancak hiçbir katmanın geçemeyeceği mutlak sert sınırları uygular. Yalnızca sistem yöneticisi tarafından yönetilir.',
    },
    setByBroker: 'Broker Tarafından Ayarlandı',
    setBySystemAdmin: 'Sistem Yöneticisi Tarafından Ayarlandı',
    goToClients: 'Müşterilere Git',
    goToAccountGroups: 'Hesap Gruplarına Git',
    goToInstruments: 'Enstrümanlara Git',
    fields: {
      maxLeverage: 'Maksimum Kaldıraç',
      maxLotSize: 'Maksimum Lot Büyüklüğü',
      marginCallLevel: 'Marjin Çağrısı Seviyesi',
      stopOutLevel: 'Stop Out Seviyesi',
      maxOpenPositions: 'Maksimum Açık Pozisyon',
      commissionPerLot: 'Lot Başına Komisyon',
      tradingDisabled: 'İşlem Devre Dışı',
      spreadMarkup: 'Spread Marjı',
      swapMarkup: 'Swap Marjı',
      tripleSwapDay: 'Üçlü Swap Günü',
      stopLevel: 'Stop Seviyesi',
      freezeLevel: 'Dondurma Seviyesi',
      defaultLeverage: 'Varsayılan Kaldıraç',
      defaultCommission: 'Varsayılan Komisyon',
      defaultMarginCall: 'Varsayılan Marjin Çağrısı',
      defaultStopOut: 'Varsayılan Stop Out',
      maxLeverageCap: 'Maksimum Kaldıraç Üst Limiti',
      minMarginCall: 'Minimum Marjin Çağrısı',
      minStopOut: 'Minimum Stop Out',
      maxCommissionCap: 'Maksimum Komisyon Üst Limiti',
      maxPositionsCap: 'Maksimum Pozisyon Üst Limiti',
    },
    fieldDescs: {
      capLeverageClient: 'Bu belirli müşteri için kaldıracı sınırla',
      limitPositionSize: 'İşlem başına pozisyon boyutunu sınırla',
      overrideAlertThreshold: 'Uyarı eşiğini geçersiz kıl',
      overrideAutoClose: 'Otomatik kapatma eşiğini geçersiz kıl',
      limitConcurrentTrades: 'Eşzamanlı işlemleri sınırla',
      customCommission: 'Özel komisyon oranı (örn. VIP = 0)',
      killSwitch: 'Bu müşteri için acil durdurma anahtarı',
      groupCommission: 'Grup geneli komisyon oranı',
      groupLeverage: 'Grup kaldıraç üst limiti',
      groupMarginCall: 'Grup uyarı eşiği',
      groupStopOut: 'Grup otomatik kapatma eşiği',
      groupPositions: 'Grup pozisyon limiti',
      groupLotSize: 'Grup işlem boyutu limiti',
      pipsAddedSpread: 'Ham spread\'e eklenen pip',
      symbolCommission: 'Sembole özgü komisyon',
      overnightSwap: 'Gecelik swap oranlarına eklenir',
      tripleSwapDay: '3x swap\'ın alındığı gün',
      symbolLeverage: 'Sembol kaldıraç üst limiti',
      symbolLotSize: 'Sembol işlem boyutu limiti',
      minSlTpDistance: 'Pip cinsinden minimum SL/TP mesafesi',
      modificationFreeze: 'Değişiklik dondurma mesafesi',
      fallbackLeverage: 'Hiçbir katman ayarlamadıysa yedek',
      fallbackCommission: 'Yedek komisyon oranı',
      fallbackMarginCall: 'Yedek uyarı seviyesi',
      fallbackStopOut: 'Yedek otomatik kapatma seviyesi',
      hardCeilingLeverage: 'Sert tavan — hiçbir katman aşamaz',
      hardFloorMarginCall: 'Sert taban — hiçbir katman altına inemez',
      hardFloorStopOut: 'Sert taban — hiçbir katman altına inemez',
      hardCeilingCommission: 'Komisyon sert tavanı',
      systemPositionLimit: 'Sistem geneli pozisyon limiti',
    },
  },

  emailTemplates: {
    loadingTemplates: 'E-posta şablonları yükleniyor…',
    loadingTemplate: 'Şablon yükleniyor…',
    retry: 'Tekrar Dene',
    allTemplates: '← Tüm Şablonlar',
    customised: 'Özelleştirilmiş',
    custom: 'Özel',
    default: 'Varsayılan',
    subjectLine: 'Konu Satırı',
    subjectPlaceholder: 'E-posta konusu…',
    editorTab: 'Düzenleyici',
    htmlTab: 'HTML',
    previewTab: 'Önizleme',
    variables: 'Değişkenler:',
    showLess: 'Daha Az Göster',
    clickToInsert: 'Değişken eklemek için tıklayın:',
    saveTemplate: 'Şablonu Kaydet',
    savingTemplate: 'Kaydediliyor…',
    resetToDefault: 'Varsayılana Sıfırla',
    resetting: 'Sıfırlanıyor…',
    back: 'Geri',
    resetConfirm: 'Varsayılan premium şablona sıfırla? Özelleştirmeleriniz kaybolacak.',
    subjectBodyRequired: 'Konu ve gövde zorunludur',
    activeBranding: 'Aktif Marka',
    companyName: 'Şirket Adı',
    primaryColor: 'Ana Renk',
    logoUrl: 'Logo URL',
    noLogoSet: 'Logo ayarlanmamış',
    emailFooter: 'E-posta Alt Bilgisi',
    brandingNote: 'Markanızı güncellemek için Broker Ayarları\'na gidin. Değişiklikler tüm e-posta şablonlarına otomatik olarak uygulanır.',
    editBranding: 'Markayı Düzenle',
    closeBranding: 'Markayı Kapat',
    templateListDesc: 'Düzenlemek için bir şablona tıklayın. Özelleştirilmiş şablonlar premium varsayılanları geçersiz kılar.',
    templateInfoNote: 'Varsayılan olarak işaretlenen şablonlar, markanız uygulanmış yerleşik premium tasarımı kullanır. Özelleştirmek için herhangi bir şablona tıklayın. Değişikliklerinizi geri almak için düzenleyicide Varsayılana Sıfırla\'yı kullanın.',
    loadingBranding: 'Marka yükleniyor…',
    typeDepositApproved: 'Para Yatırma Onaylandı',
    typeDepositRejected: 'Para Yatırma Reddedildi',
    typeWithdrawalApproved: 'Para Çekme Onaylandı',
    typeWithdrawalRejected: 'Para Çekme Reddedildi',
    typeMarginCall: 'Marjin Çağrısı',
    typeLiquidation: 'Hesap Tasfiye Edildi',
    typeKycApproved: 'KYC Onaylandı',
    typeKycRejected: 'KYC Reddedildi',
    typeWelcome: 'Hoş Geldin E-postası',
  },

  credits: {
    activeRules: 'Aktif Kurallar',
    totalAwarded: 'Toplam Verilen',
    awardEvents: 'Ödül Olayları',
    bonusRules: 'Bonus Kuralları',
    awardHistory: 'Ödül Geçmişi',
    newRule: 'Yeni kural',
    manualAward: 'Manuel ödül',
    noBonusRules: 'Henüz bonus kuralı yok. Para yatırmalarda otomatik kredi vermeye başlamak için bir tane ekleyin.',
    noCreditAwards: 'Henüz kredi ödülü yok.',
    deactivateConfirm: 'Bu kural devre dışı bırakılsın mı?',
    revokeReason: 'İptal nedeni (isteğe bağlı):',
    operationFailed: 'İşlem başarısız',
    bonusRuleTitle: '{mode} Bonus Kuralı',
    ruleName: 'Kural adı (örn. Hoş Geldin Bonusu)',
    percentOfDeposit: 'Yatırımın %\'si (örn. 20)',
    fixedAmountUsd: 'Sabit tutar (USD)',
    maxCreditCap: 'Maksimum kredi üst limiti (isteğe bağlı)',
    minDepositQualify: 'Uygun olmak için minimum yatırım',
    expiresAfterDays: 'N gün sonra sona erer (isteğe bağlı)',
    ruleActive: 'Aktif — uygun yatırımlarda otomatik olarak verilir',
    ruleDisabled: 'Devre Dışı',
    savingDots: 'Kaydediliyor…',
    awardingDots: 'Veriliyor…',
    manualCreditAward: 'Manuel Kredi Ödülü',
    accountId: 'Hesap ID',
    userId: 'Kullanıcı ID',
    amountUsd: 'Tutar (USD)',
    notesOptional: 'Notlar (isteğe bağlı)',
    awardCredit: 'Kredi Ver',
    infoWelcomeDeposit: 'HOŞ GELDİN ve YATIRIM kuralları para yatırma onayında otomatik olarak tetiklenir. İYİNİYET ve PROMOSYON manuel olarak verilir. Kredi, tasfiye durumunda silinir.',
    bonusWelcome: 'Hoş Geldin',
    bonusDeposit: 'Yatırım',
    bonusGoodwill: 'İyiniyet',
    bonusPromotion: 'Promosyon',
    statusRevoked: 'İptal Edildi',
    statusExpired: 'Süresi Doldu',
  },

  pages: {
    websitePages: 'Web Sitesi Sayfaları',
    websitePagesDesc: 'Web sitenizi oluşturun ve yönetin.',
    pluginNotActive: 'Eklenti aktif değil.',
    viewPlugins: 'Eklentileri Görüntüle',
    mainPages: 'Ana Sayfalar',
    legalPages: 'Yasal Sayfalar',
    langs: 'dil',
    save: 'Kaydet',
    saved: 'Kaydedildi',
    error: 'Hata',
    publish: 'Yayınla',
    unpublish: 'Yayından Kaldır',
    published: 'Yayınlandı',
    draft: 'Taslak',
    tabBlocks: 'Bloklar',
    tabSeo: 'SEO',
    addBlock: 'Blok Ekle',
    addFirstBlock: 'İlk Bloğu Ekle',
    addFirstBlockHint: 'İlk içerik bloğunuzu ekleyin',
    noBlocks: 'Henüz blok yok',
    pageTitle: 'Sayfa Başlığı',
    pageTitleHint: 'Bu, navigasyon ve sayfa başlığında gösterilen ana sayfa başlığıdır',
    translatable: 'Çevrilebilir',
    pageSlug: 'Sayfa Slug\'ı',
    seoTitle: 'SEO Başlığı',
    seoDescription: 'SEO Açıklaması',
    googlePreview: 'GOOGLE ÖNİZLEMESİ',
    noDescription: 'Açıklama yok.',
    catHeroLayout: 'Hero ve Düzen',
    catContent: 'İçerik',
    catFeaturesData: 'Özellikler ve Veriler',
    catSocialProof: 'Sosyal Kanıt',
    catCta: 'Harekete Geçirici Mesaj',
    catDocuments: 'Belgeler ve Yasal',
    catOther: 'Diğer',
    missing: 'Eksik',
    add: 'Ekle',
    addItem: 'Öğe Ekle',
    item: 'Öğe',
    notStarted: 'Başlamadı',
  },

  userOverride: {
    title: 'Kullanıcı Hesabı Geçersiz Kılma',
    infoBannerTitle: 'Kullanıcı Seviyesi Geçersiz Kılmalar (Katman 1)',
    infoBannerDesc: 'Bu ayarlar, kullanıcının hesap grubu varsayılanlarını geçersiz kılar. Grup ayarlarını kullanmak için alanları boş (NULL) bırakın.',
    sectionTradingControl: 'İşlem Kontrolü',
    sectionRiskParameters: 'Risk Parametreleri',
    sectionPricingOverrides: 'Fiyat Geçersiz Kılmaları',
    disableTrading: 'İşlemi Devre Dışı Bırak',
    disableTradingSubLabel: 'Bu kullanıcının yeni pozisyon açmasını önle',
    resetToGroupDefault: 'Grup Varsayılanına Sıfırla',
    groupDefault: 'Grup Varsayılanı',
    maxLeverage: 'Maksimum Kaldıraç',
    maxLotSize: 'Maksimum Lot Büyüklüğü',
    minLotSize: 'Minimum Lot Büyüklüğü',
    marginCallLevel: 'Marjin Çağrısı Seviyesi (%)',
    stopOutLevel: 'Stop Out Seviyesi (%)',
    maxOpenPositions: 'Maksimum Açık Pozisyon',
    commissionPerLot: 'Lot Başına Komisyon (USD)',
    commissionPerLotHint: 'İşlem yapılan standart lot başına alınan USD',
    minAboveMaxError: '⚠️ Minimum lot büyüklüğü maksimumu aşamaz',
    currentOverrideTitle: 'Aktif Geçersiz Kılma',
    currentOverrideDesc: 'Bu kullanıcı, hesap grubu varsayılanlarını geçersiz kılan özel ayarlara sahip.',
    saveOverride: 'Geçersiz Kılmayı Kaydet',
    saving: 'Kaydediliyor...',
    saveSuccess: 'Kullanıcı geçersiz kılma başarıyla kaydedildi',
    saveFailed: 'Kullanıcı geçersiz kılma kaydedilemedi',
    lots: 'lot',
    lotStep: 'Lot adımı',
  },

  symbolSettings: {
    sectionPricing: 'Broker Fiyatlandırması',
    sectionRisk: 'Risk Limitleri',
    sectionExecution: 'Çalıştırma Kuralları',
    sectionOverrides: 'Enstrüman Geçersiz Kılmaları',
    sectionsLabel: 'Bölümler',
    pricingDesc: 'Bu broker için ham enstrüman oranlarının üzerine uygulanan ayarlamalar.',
    riskDesc: 'Bu broker seviyesinde uygulanan pozisyon ve kaldıraç limitleri.',
    executionDesc: 'Emir yerleştirme ve değiştirme kısıtlamaları.',
    overridesDesc: 'Broker seviyesi geçersiz kılmayı etkinleştirmek için her alanı değiştirin. Devre dışı bırakılan alanlar paylaşılan enstrüman tablosuna geri döner.',
    overridesInfoTitle: 'Uzun Swap / Kısa Swap',
    overridesInfoDesc: 'etkinleştirildiğinde enstrüman oranını tamamen değiştirir — swap marjı üstüne eklenmez. Diğer tüm geçersiz kılmalar normal şekilde basamaklanır.',
    settingsTitle: '{symbol} Ayarları',
    headerSubtitle: 'Broker seviyesi fiyatlandırma ve riski yapılandırın (Katman 3)',
    overrideActive: '{count} geçersiz kılma aktif',
    overridesActive: '{count} geçersiz kılma aktif',
    spreadMarkup: 'Spread Marjı',
    spreadMarkupHint: 'Likidite sağlayıcısının ham spread\'ine eklenen pip',
    commissionPerLot: 'Lot Başına Komisyon',
    commissionPerLotHint: 'İşlem yapılan standart lot başına alınan USD',
    swapMarkup: 'Swap Marjı',
    swapMarkupHint: 'Enstrüman swap oranlarının üzerine eklenen puan. swap_long / swap_short geçersiz kılmaları etkinleştirildiğinde yok sayılır.',
    tripleSwapDay: 'Üçlü Swap Günü',
    tripleSwapDayHint: 'Üçlü swap\'ın alındığı gün',
    maxLeverage: 'Maksimum Kaldıraç',
    maxLeverageHint: 'Bu sembol için izin verilen maksimum kaldıraç',
    maxLotSize: 'Maksimum Lot Büyüklüğü',
    maxLotSizeHint: 'İşlem başına maksimum pozisyon boyutu',
    minLotSize: 'Minimum Lot Büyüklüğü',
    minLotSizeHint: 'İşlem başına minimum pozisyon boyutu',
    minAboveMaxError: '⚠️ Minimum lot büyüklüğü maksimumu aşamaz',
    stopLevel: 'Stop Seviyesi',
    stopLevelHint: 'Mevcut piyasa fiyatından SL/TP için minimum mesafe (pip)',
    freezeLevel: 'Dondurma Seviyesi',
    freezeLevelHint: 'Emir değişikliklerinin dondurulduğu mesafe (pip)',
    contractSize: 'Kontrat Büyüklüğü',
    contractSizeHint: 'Lot başına birim. Standart forex için 100000, hisseler için 1.',
    priceScale: 'Fiyat Ölçeği',
    priceScaleHint: 'Fiyat kotasyonu için ondalık basamak. 5 = 1.23456, 2 = 1.23.',
    swapLong: 'Uzun Swap (doğrudan oran)',
    swapLongHint: 'ALIŞ pozisyonları için gecelik oran. Enstrüman oranını tamamen değiştirir.',
    swapShort: 'Kısa Swap (doğrudan oran)',
    swapShortHint: 'SATIŞ pozisyonları için gecelik oran. Enstrüman oranını tamamen değiştirir.',
    swapMode: 'Swap Modu',
    swapModeHint: 'Gecelik swap oranının nasıl hesaplandığı',
    maxVolume: 'Maksimum Hacim (lot)',
    maxVolumeHint: 'Bu broker için lot cinsinden maksimum tek işlem büyüklüğü.',
    volumeStep: 'Hacim Adımı (lot)',
    volumeStepHint: 'Minimum işlem boyutu artışı. Örn. 0.01, 0.01, 0.02, 0.03\'e izin verir…',
    defaultBadge: 'varsayılan',
    pips: 'pip',
    pts: 'puan',
    lots: 'lot',
    decimals: 'ondalık',
    dayMon: 'Pzt',
    dayTue: 'Sal',
    dayWed: 'Çar',
    dayThu: 'Per',
    dayFri: 'Cum',
    daySat: 'Cmt',
    daySun: 'Paz',
    loadingSettings: 'Ayarlar yükleniyor…',
    saveSettings: 'Ayarları Kaydet',
    lotStep: 'Lot adımı',
  },

  accountGroupForm: {
    sectionsLabel: 'Bölümler',
    sectionBasic: 'Temel Bilgiler',
    sectionPricing: 'Fiyat Geçersiz Kılmaları',
    sectionRisk: 'Risk Yönetimi',
    editTitle: 'Hesap Grubunu Düzenle',
    createTitle: 'Hesap Grubu Oluştur',
    basicInfoTitle: 'Temel Bilgiler',
    groupNameLabel: 'Grup Adı *',
    groupNamePlaceholder: 'Standart Grup',
    descriptionLabel: 'Açıklama',
    descriptionPlaceholder: 'Grup açıklaması...',
    groupActive: 'Grup Aktif',
    defaultGroup: 'Varsayılan Grup',
    pricingTitle: 'Fiyat Geçersiz Kılmaları',
    pricingDesc: 'Broker düzeyindeki varsayılanları kullanmak için boş bırakın. Yalnızca bu grubun farklı fiyatlandırmaya ihtiyacı varsa geçersiz kılın.',
    commissionPerLot: 'Lot Başına Komisyon (USD)',
    commissionPerLotHint: 'İşlem yapılan standart lot başına alınan USD',
    maxLeverage: 'Maksimum Kaldıraç',
    maxLeverageHint: 'Bu grup için kullanılabilir maksimum kaldıraç',
    brokerDefault: 'Broker Varsayılanı',
    resetToNoLimit: 'Limit yok olarak sıfırla',
    riskTitle: 'Risk Yönetimi',
    marginCallLevel: 'Marjin Çağrısı Seviyesi',
    marginCallHint: 'Marjin seviyesi bu yüzdeye ulaştığında uyar',
    stopOutLevel: 'Stop Out Seviyesi',
    stopOutHint: 'Bu marjin seviyesinde pozisyonları otomatik kapat',
    maxOpenPositions: 'Maksimum Açık Pozisyon',
    maxOpenPositionsHint: 'Hesap başına maksimum pozisyon sayısı',
    maxLotSize: 'Maksimum Lot Büyüklüğü',
    maxLotSizeHint: 'İşlem başına maksimum lot büyüklüğü',
    minLotSize: 'Minimum Lot Büyüklüğü',
    minLotSizeHint: 'Bu grup için işlem başına minimum lot büyüklüğü',
    noLimit: 'Limit Yok',
    lots: 'lot',
    marginBelowStopError: '⚠️ Marjin Çağrısı Seviyesi, Stop Out Seviyesinden büyük olmalıdır',
    minAboveMaxError: '⚠️ Minimum lot büyüklüğü maksimumu aşamaz',
    updateGroup: 'Grubu Güncelle',
    createGroup: 'Grup Oluştur',
    lotStep: 'Lot adımı',
  },

  cryptoCheckout: {
    paymentConfirmedTitle: 'Ödeme Onaylandı!',
    makePayment: 'Ödeme Yap',
    depositFunds: 'Para Yatır',
    purchaseItem: '{name} Satın Al',
    subscribeTo: '{name}\'e Abone Ol',
    selectPaymentMethod: 'Ödeme yöntemi seçin',
    payWith: '{currencies} ile öde',
    creatingPayment: 'Ödeme oluşturuluyor...',
    continue: 'Devam Et',
    sendExactly: 'Tam olarak gönder',
    approxUsd: '≈ ${amount} USD',
    hideQrCode: 'QR Kodu Gizle',
    showQrCode: 'QR Kodu Göster',
    scanWithWallet: 'Mobil cüzdanınızla tarayın',
    toThisAddress: 'Bu {network} adresine',
    expiresIn: 'Sona erme',
    waitingForPayment: 'Ödeme bekleniyor...',
    waitingDesc: 'Tam tutarı gönderin. Otomatik olarak tespit edeceğiz.',
    verifiedOnChain: 'AmorPay tarafından zincir üzerinde doğrulandı. Aracı yok.',
    pluginActivated: '{name} etkinleştirildi.',
    depositCredited: 'Para yatırmanız hesabınıza yatırıldı.',
    subscriptionActive: 'Aboneliğiniz artık aktif.',
    paymentConfirmed: 'Ödemeniz onaylandı.',
    done: 'Tamam',
    noItemSelected: 'Satın alma için öğe seçilmedi',
    failedToLoadOptions: 'Ödeme seçenekleri yüklenemedi',
  },

  subscriptionGate: {
    accountSuspended: 'Hesap Askıya Alındı',
    subscriptionExpired: 'Abonelik Sona Erdi',
    suspendedDesc: 'Hesabınız askıya alındı. Erişimi geri yüklemek için destekle iletişime geçin.',
    expiredDesc: '{plan} aboneliğinizin süresi doldu ve tolerans süresi sona erdi. Tam erişimi geri yüklemek için yenileyin.',
    renewSubscription: 'Aboneliği Yenile',
    signOut: 'Çıkış Yap',
    needHelp: 'Yardıma mı ihtiyacınız var? İletişim:',
    lastChance: '⚠️ Son şans! {plan} aboneliğinizin süresi doldu. Erişim bugün sona eriyor.',
    gracePeriodDay: '{plan} aboneliğinizin süresi doldu. Tolerans sürenizde {days} gün kaldı.',
    gracePeriodDays: '{plan} aboneliğinizin süresi doldu. Tolerans sürenizde {days} gün kaldı.',
    renewNow: 'Şimdi Yenile',
  },

  upgradePage: {
    renewTitle: 'Aboneliği Yenile',
    upgradeTitle: 'Planınızı Yükseltin',
    currentlyOn: 'Mevcut plan',
    graceDaysLeft: 'Tolerans süresinde {days} gün kaldı',
    graceDaysLeftPlural: 'Tolerans süresinde {days} gün kaldı',
    expired: 'Süresi Doldu',
    graceWarning: 'Aboneliğinizin süresi doldu. Hesabınız kilitlenmeden önce yenilemek için {days} gününüz var.',
    graceWarningPlural: 'Aboneliğinizin süresi doldu. Hesabınız kilitlenmeden önce yenilemek için {days} gününüz var.',
    expiredWarning: 'Aboneliğinizin süresi tamamen doldu. Erişimi geri yüklemek için şimdi yenileyin.',
    renewOrUpgrade: 'Mevcut planınızı yenileyebilir veya daha yüksek bir seviyeye yükseltebilirsiniz.',
    monthly: 'Aylık',
    yearly: 'Yıllık',
    mostPopular: 'En Popüler',
    currentPlan: 'Mevcut Plan',
    perMonth: '/ay',
    saveYearly: '%10 tasarruf edin — ${amount}/yıl faturalandırılır',
    unlimitedTraders: 'Sınırsız trader',
    tradersCount: '{count} trader',
    unlimitedAdmins: 'Sınırsız yönetici',
    adminsCount: '{count} yönetici',
    unlimitedInstruments: 'Sınırsız enstrüman',
    instrumentsCount: '{count} enstrüman',
    feedUltra: 'Ultra düşük gecikmeli feed',
    feedPriority: 'Öncelikli feed',
    feedStandard: 'Standart feed',
    fullApiAccess: 'Tam API erişimi',
    selected: 'Seçildi',
    selectPlan: 'Plan Seç',
    fullComparison: 'Tam karşılaştırma',
    featureCol: 'Özellik',
    featureTraders: 'Traderlar',
    featureAdmins: 'Yöneticiler',
    featureInstruments: 'Enstrümanlar',
    featureFeedLatency: 'Feed Gecikmesi',
    featureApiAccess: 'API Erişimi',
    featureForex: 'Forex',
    featureCrypto: 'Kripto',
    featureCommodities: 'Emtialar',
    featureIndices: 'Endeksler',
    featureStocks: 'Hisseler',
    selectedPlan: 'Seçilen:',
    selectToContinue: 'Devam etmek için bir plan seçin',
    perYear: '/yıl',
    renewNow: 'Şimdi Yenile',
    upgradeNow: 'Şimdi Yükselt',
    failedToLoadPlans: 'Planlar yüklenemedi',
    selectPlanFirst: 'Lütfen önce bir plan seçin',
    planActivated: '{name} planı etkinleştirildi! 🎉',
  },
  sidebar: {
    sectionOverview: 'Genel Bakış',
    sectionManagement: 'Yönetim',
    sectionTrading: 'İşlem',
    sectionFinance: 'Finans',
    sectionPlugins: 'Eklentiler',
    sectionSystem: 'Sistem',
    accountGroups: 'Hesap Grupları',
    cascadeGuide: 'Basamak Kılavuzu',
    pluginStore: 'Eklenti Mağazası',
    kycVerification: 'KYC Doğrulama',
    kycDashboard: 'KYC Paneli',
    kycConfig: 'KYC Yapılandırma',
    pages: 'Sayfalar',
    credits: 'Krediler',
    emailTemplates: 'E-posta Şablonları',
    restApi: 'REST API',
    advancedAnalytics: 'Gelişmiş Analitik',
    descClients: 'Kullanıcılar · Ayarlar · Geçersiz Kılmalar',
    descGroups: 'Gruplar · Ayarlar · Geçersiz Kılmalar',
    descInstruments: 'Broker · Ayarlar · Geçersiz Kılmalar',
    descAccounts: 'Hesaplar ve bakiyeler',
    descCascade: 'Öncelik sistemi açıklaması',
    descAnalytics: 'Yapay zeka destekli içgörüler',
    badgeLive: 'Canlı',
    badgeActive: 'Aktif',
    badgeAddon: 'Eklenti',
    badgePro: 'PRO',
    badgeApi: 'API',
    badgeConfig: 'Yapılandırma',
    badgeHowItWorks: 'Nasıl çalışır',
    cascadeTipFallthrough: 'Bir sonraki katmana geçmek için alanları boş bırakın',
  },
};